import axios from "axios";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Cart from "./Component/Cart";
import ErrorPage from "./Component/ErrorPage";
import Login from "./Component/Login";
// import Banner from "./Component/Banner";
import Navber from "./Component/Navber";
import PlaceOrder from "./Component/PlaceOrder";
import Product from "./Component/Product";
import SingleProduct from "./Component/SingleProduct";
import { useStateValue } from "./StateProvider";

function App() {
  const [{products},dispatch]=useStateValue();
  const API = "https://dummyjson.com/products";
  const getProducts = async (url) => {
    const { data } = await axios.get(url);
    // console.log(data.products,'455');
    dispatch({
      type:"ADD_PRODUCTS",
      item:data.products,
    })

  };
  useEffect(() => {
    getProducts(API);
  }, []);
  return (
    <BrowserRouter>
      <div className="App">
        {/* navbar */}
        <Navber />
        <Routes>
          <Route path="/" element={<Product />} />
          <Route path="/:pramsId" element={<SingleProduct />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cart" element={<Cart />} />
          <Route path='*' element={<ErrorPage />} />
          <Route path='/seller' element={<ErrorPage />} />
          <Route path='/order' element={<PlaceOrder />} />
        </Routes>
        {/* products */}

        {/* single product */}
        {/* footer */}
      </div>
    </BrowserRouter>
  );
}

export default App;
